module.exports = __webpack_public_path__ + "static/media/ktx_hover.6fafda83.svg";